import type { Module } from 'vuex';
import { IndicatorParam } from '@/types/IndicatorParam';
import {RootState} from "@/store";

export interface IndicatorParamsState {
  indicatorParams: IndicatorParam[];
}

const indicatorParamsModule: Module<IndicatorParamsState, RootState> = {
  namespaced: true,
  state: () => ({
    indicatorParams: [],
  }),
  getters: {
    getNameById: (state) => (idIndicatorParam: number): string => {
      const indicatorParam = state.indicatorParams.find(indicatorParam => indicatorParam.idIndicatorParam === idIndicatorParam);
      return indicatorParam ? indicatorParam.name : 'Unknown';
    },
  },
  mutations: {
    setIndicatorParams(state, payload: { indicatorParams: Record<number, any> | any[] }) {
      const indicatorParams = Array.isArray(payload.indicatorParams)
        ? payload.indicatorParams
        : Object.values(payload.indicatorParams);
      state.indicatorParams = indicatorParams.map(raw => IndicatorParam.fromRaw(raw));
    },
    addIndicatorParam(state, payload: any) {
      state.indicatorParams.push(IndicatorParam.fromRaw(payload));
    },
    updateIndicatorParam(state, payload: any) {
      const index = state.indicatorParams.findIndex(indicatorParam => indicatorParam.idIndicatorParam === payload.idIndicatorParam);
      
      if (index !== -1) {
        state.indicatorParams[index] = IndicatorParam.fromRaw(payload);
      }
    },
    deleteIndicatorParam(state, payload: { idIndicatorParam: number }) {
      state.indicatorParams = state.indicatorParams.filter(
        indicatorParam => indicatorParam.idIndicatorParam !== payload.idIndicatorParam
      );
    },
  },
  actions: {
    wsSetIndicatorParams({ commit }, payload) {
      commit('setIndicatorParams', payload);
    },
    wsIndicatorParamCreate({ commit }, payload) {
      commit('addIndicatorParam', payload);
    },
    wsIndicatorParamUpdate({ commit }, payload) {
      commit('updateIndicatorParam', payload);
    },
    wsIndicatorParamDelete({ commit }, payload) {
      commit('deleteIndicatorParam', payload);
    },
  },
};

export default indicatorParamsModule; 